import tinycolor from 'tinycolor2';
import { Color } from './types';

const PERCENT = 5;

export const generateColorPalette = (color: string, percent = PERCENT): Color => {
  const tColor = tinycolor(color);

  const hsl = tColor.toHsl();
  const colorS = hsl.s * 100;
  const colorL = hsl.l * 100;

  const colorName = 'base';
  const colorHex = tColor.toHexString();

  const palette = {
    [colorName]: colorHex
  };

  for (let i = 1; i < 100; i = i + percent) {
    // lighten
    const lighten = colorL + i;
    const lightColor = tinycolor(color).lighten(i);
    const lightHex = lightColor.toHexString();
    const lightName = `lighten${i}`;

    // darken
    const darken = colorL - i;
    const darkColor = tinycolor(color).darken(i);
    const darkHex = darkColor.toHexString();
    const darkName = `darken${i}`;

    // saturate
    const saturate = colorS + i;
    const satColor = tinycolor(color).saturate(i);
    const satHex = satColor.toHexString();
    const satName = `sat${i}`;

    // desaturate
    const desaturate = colorS - i;
    const desColor = tinycolor(color).desaturate(i);
    const desHex = desColor.toHexString();
    const desName = `des${i}`;

    if (lighten <= 100) {
      Object.assign(palette, { [lightName]: lightHex });
    }

    if(darken >= 0) {
      Object.assign(palette, { [darkName]: darkHex });
    }

    if(saturate <= 100) {
      Object.assign(palette, { [satName]: satHex });
    }

    if(desaturate >= 0) {
      Object.assign(palette, { [desName]: desHex });
    }

    // reset the loop the first iteration for continuing with the percent increase
    if (i === 1) { i = 0 }
  }

  return palette as Color;
}
